import React, { Component } from 'react';

// ACQ components
import ajax from 'service_modules/xml-http-requests/card-shop-api-v1.ajax';
import { intlPage } from 'acq-gcs-pages/lib/universal/redux/reducers/pageData';
import { translateCardShortName } from 'acq-gcs-pages/lib/universal/translations';
import getCountryCode from 'src/util-getCountryCodeFromUrl';

export const withGraphqlData = configs => WrappedComponent => {
  return class extends Component {
    state = { intlPage: {} };

    static reducer = { name: 'intlPage', func: intlPage };
    static action = 'PAGE_DATA_RECEIVED';

    static mapSsrFetchToStore = fetchedData => {
      return {
        intlPage: intlPage(
          {},
          {
            type: 'PAGE_DATA_RECEIVED',
            payload: {
              ...fetchedData,
              httpStatus: 200
            }
          }
        )
      };
    };

    static fetchData(routeInfo, requestConfig = {}) {
      const {
        params,
        location: {
          query: { ieep }
        }
      } = routeInfo;
      const shop = configs.isCorporate ? 'corporate' : 'business';
      const { countryCode, language } = getCountryCode(params);
      const variables = {
        country: configs.countryCodeOnly
          ? countryCode
          : `${language}_${countryCode}`,
        shop,
        page:
          params.page ||
          translateCardShortName(countryCode, shop, params.cardName) ||
          configs.page ||
          'vac',
        eep: ieep
      };

      return ajax
        .graphQLPost(
          { query: configs.query, variables },
          {
            'set-cookie': params['set-cookie'],
            queryName: `${variables.page}_${variables.shop}_query`.toUpperCase(),
            skipParser: true
          }
        )
        .then(response => {
          const { status, data } = response;
          if (status !== 200) {
            throw new Error(
              `GRAPHQL request failed: ${JSON.stringify(response, null, 2)}`
            );
          } else if (data && !data.cardShop) {
            throw new Error(`GRAPHQL<404>: ${JSON.stringify(response, null, 2)}`);
          }

          return data;
        })
        .then(({ cardShop }) => {
          if (cardShop && configs.dataMapper) {
            return configs.dataMapper(cardShop);
          }
          return cardShop;
        })
        .then(data => {
          // In the Terms and Conditions page & the VAC page, "cards" is located in "data"
          // In PDP, "cards" is located in "data.rawData"
          if (!configs.isTNC) {
            const cardDataFound =
              !!data && (!!data.cards || !!(data.rawData && data.rawData.cards));
            if (!cardDataFound) {
              throw new Error('Card Data Not Found');
            }

            if (!configs.dataMapper) {
              Object.assign(
                data,
                intlPage(
                  {},
                  {
                    type: 'PAGE_DATA_RECEIVED',
                    payload: data
                  }
                )
              );
            }
          }

          const pageData = data
            ? Object.assign(data, {
                httpStatus: 200,
                pageName: variables.page
              })
            : {};
          return {
            headers: { 'set-cookie': requestConfig['set-cookie'] },
            dataKey: 'intlPage',
            dataForServerRender: pageData,
            rawData1: pageData
          };
        });
    }

    render() {
      const newProps = {
        ...this.state,
        ...this.props
      };
      return (
        <WrappedComponent {...newProps}>{this.props.children}</WrappedComponent>
      );
    }
  };
};
